<div class="container-contact100">
  <div class="wrap-contact100">
    <p class="p-4 w-100 font-weight-bold">Support for Mobile Devices is Coming Soon <br> In the meantime you can connect via Your PC / Laptop</p>
  </div>
</div>
